import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';

import reducers from './redux/reducer';

export const history = createBrowserHistory();

const store = configureStore({
  reducer: { ...reducers },
  devTools: process.env.NODE_ENV === 'development',
});

export default store;
